import { Icon } from '@ps/isp-web-component-library';
import { Account } from '@ps/isp-web-component-library/icons/Account';
import React from 'react';
import { useSelector } from 'react-redux';

import BalanceAmount from '@swf/components/CurrencyAmount/BalanceAmount';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';

import { TXTWCL_Account_22 } from './OpenMobileBetSlipHeaderContent.messages.json';

const OpenMobileBetSlipHeaderContent: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();
  const { showBalance } = useSelector(select.localSettings.get);
  const playChips = useSelector(select.account.getPlayChips);
  const totalBalance = useSelector(select.account.getTotalBalance);
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const balance = isPlayMoney ? playChips : totalBalance;

  return (
    <>
      <Icon icon={Account} size="x1" aria-label={formatMessage(TXTWCL_Account_22)} />
      <div>{showBalance && <BalanceAmount value={balance as number} />}</div>
    </>
  );
};

export default OpenMobileBetSlipHeaderContent;
